module.exports = __webpack_public_path__ + "img/undraw_qa_engineers_dg-5-p.14f17235.svg";